import Immutable from "seamless-immutable";
import * as types from "./types";

const initialState = Immutable({
  listMenu: [],
  isLoadMenuDone: false,
  listStaff: [],
  isLoadStaffDone: false,
  listTable: [],
  isLoadTableDone: false,
  listCustomer: [],
  isLoadCustomer: false,
  listParticipants: [],
  isLoadParticipants: false,
});

const setListMenu = (action, state) => {
  const { payload: listMenu } = action;
  return state.merge({ listMenu, isLoadMenuDone: true });
};

const setListStaff = (action, state) => {
  const { payload: listStaff } = action;
  return state.merge({ listStaff, isLoadStaffDone: true });
};

const setListTable = (action, state) => {
  const { payload: listTable } = action;
  return state.merge({ listTable, isLoadStaffDone: true });
};

const setListCustomer = (action, state) => {
  const { payload: listCustomer } = action;
  return state.merge({ listCustomer, isLoadCustomer: true });
};

const setListParticipants = (action, state) => {
  const { payload: listParticipants } = action;
  return state.merge({ listParticipants, isLoadParticipants: true });
};
const dispatch = {
  [types.SET_LIST_MENU]: setListMenu,
  [types.SET_LIST_STAFF]: setListStaff,
  [types.SET_LIST_TABLE]: setListTable,
  [types.SET_LIST_CUSTOMER]: setListCustomer,
  [types.SET_LIST_PARTICIPANTS]: setListParticipants,
};

const reducer = (state, action) => {
  if (typeof state === "undefined") {
    return initialState;
  }
  return typeof dispatch[action.type] === "function"
    ? dispatch[action.type](action, state)
    : state;
};

export default reducer;
